<template>
    <div v-if="data.links.length > 3">
        <nav class="bg-white dark:bg-gray-800 px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" aria-label="Pagination">
            <div class="hidden sm:block">
                <p class="text-sm text-gray-700 dark:text-white">
                    Showing
                    {{ ' ' }}
                    <span class="font-medium">{{ data.from }}</span>
                    {{ ' ' }}
                    to
                    {{ ' ' }}
                    <span class="font-medium">{{ data.to }}</span>
                    {{ ' ' }}
                    of
                    {{ ' ' }}
                    <span class="font-medium">{{ data.total }}</span>
                    {{ ' ' }}
                    results
                </p>
            </div>
            <div class="flex-1 flex justify-between sm:justify-end">
                <Link v-if="data.prev_page_url" method="get" :href="data.prev_page_url" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Previous
                </Link>
                <Link v-if="data.next_page_url" method="get" :href="data.next_page_url" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Next
                </Link>
            </div>
        </nav>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        data: Object
    },
    components: {
        Link,
    }
}

</script>
